var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"pt-0 px-2 pb-0",attrs:{"dense":"","nav":""}},[_c('div',{staticClass:"d-flex",style:({ height: '48px' })},[_c('v-img',{attrs:{"src":_vm.cdn_url('core/white_logo.svg'),"width":"80px","max-width":"80px","contain":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }